<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />

    <!-- นำทาง -->
    <v-card class="v-card-bottom-30">
      <v-card-title>
        {{ use_language.oms }}
        <v-icon>mdi-chevron-right</v-icon>
        {{ use_language.stock }}
      </v-card-title>
    </v-card>

    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title class="height-57">
        <v-icon size="22" color="success darken-3">mdi-package-variant-closed</v-icon><span class="ml-3">{{ use_language.stock_by_location }}</span>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-row>
          <!-- ผู้ใช้ที่สังกัด location เดียวไม่ต้องเลือก -->
          <v-col v-if="locations.length > 1" cols="12" md="4" class="pa-1">
            <v-autocomplete
              v-model="filter.locationId"
              :items="locationItems"
              :label="use_language.location"
              outlined
              dense
              hide-details
              @change="search()"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="filter.keyword"
              :placeholder="use_language.search + ' ' + use_language.product + ' / ' + use_language.sku"
              prepend-inner-icon="mdi-magnify"
              autocomplete="off"
              outlined
              dense
              hide-details
              clearable
              @keyup.enter="search()"
              @click:clear="filter.keyword = null; search()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="pa-1 d-flex align-center">
            <v-checkbox v-model="filter.onlyAvailable" :label="use_language.only_available" hide-details class="mt-0" @change="search()"></v-checkbox>
            <v-spacer/>
            <v-btn :elevation="1" color="primary" class="px-2" @click="search()">{{ use_language.search }}</v-btn>
          </v-col>
        </v-row>

        <div v-if="locations.length == 0" class="text-center py-6" style="color: #9e9e9e;">{{ use_language.no_location_assigned }}</div>
        <div v-else>
          <!-- PC hidden-xs-only -->
          <v-data-table
            :headers="header"
            :items="items"
            :items-per-page="take"
            hide-default-footer
            :no-data-text="use_language.no_data"
            class="packhai-border-table hidden-xs-only mt-3"
          >
            <template v-slot:item.locationName="{ item }">{{ item.channel }} : {{ item.locationName }}</template>
            <template v-slot:item.photoLink="{ item }">
              <v-img v-if="item.photoLink" :src="item.photoLink" width="44" height="44" contain class="my-1 mx-auto"></v-img>
            </template>
            <template v-slot:item.productName="{ item }">
              <div>{{ item.productName }}</div>
              <div style="font-size: 12px; color: #9e9e9e;">{{ item.sku }}</div>
            </template>
            <template v-slot:item.quotaQty="{ item }">{{ formatMoney(String(item.quotaQty)) }}</template>
            <template v-slot:item.reservedQty="{ item }">{{ formatMoney(String(item.reservedQty)) }}</template>
            <template v-slot:item.usedQty="{ item }">{{ formatMoney(String(item.usedQty)) }}</template>
            <template v-slot:item.availableQty="{ item }">
              <b :style="item.availableQty > 0 ? 'color: darkgreen;' : 'color: red;'">{{ formatMoney(String(item.availableQty)) }}</b>
            </template>
          </v-data-table>

          <!-- Mobile hidden-sm-and-up -->
          <v-data-iterator
            :items="items"
            :items-per-page="take"
            hide-default-footer
            :no-data-text="use_language.no_data"
            class="hidden-sm-and-up mt-3"
          >
            <template v-slot:default="props">
              <v-row>
                <v-col v-for="item in props.items" :key="item.locationID + '_' + item.stockShopID" cols="12" class="pa-1">
                  <v-card>
                    <v-row class="pa-2">
                      <v-col cols="12" class="pa-0"><b>{{ item.productName }}</b></v-col>
                      <v-col cols="12" class="pa-0" style="font-size: 12px; color: #9e9e9e;">{{ item.sku }}</v-col>
                      <v-col cols="12" class="pa-0">{{ use_language.location }} : {{ item.channel }} : {{ item.locationName }}</v-col>
                      <v-col cols="6" class="pa-0">{{ use_language.quota_qty }} : {{ formatMoney(String(item.quotaQty)) }}</v-col>
                      <v-col cols="6" class="pa-0">{{ use_language.reserved_qty }} : {{ formatMoney(String(item.reservedQty)) }}</v-col>
                      <v-col cols="6" class="pa-0">{{ use_language.used_qty }} : {{ formatMoney(String(item.usedQty)) }}</v-col>
                      <v-col cols="6" class="pa-0">
                        {{ use_language.available_qty }} :
                        <b :style="item.availableQty > 0 ? 'color: darkgreen;' : 'color: red;'">{{ formatMoney(String(item.availableQty)) }}</b>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>

          <div class="pt-3">
            <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="7" @input="Load_data()"></v-pagination>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import Loading from '@/website/components/Loading'
  import { formatMoney } from '@/website/global_function'
  import { getOmsLanguage } from '@/website/backend/oms/oms_language'
  import { getOmsContext, getStockList } from '@/website/backend/oms/oms_service'

  export default {
    components: {
      Loading
    },
    data: () => ({
      // page
      page_loading: true,
      loading: false,
      use_language: getOmsLanguage(),

      locations: [],  // location ที่ผู้ใช้มีสิทธิ์ (Admin = ทุก location)
      filter: { locationId: null, keyword: null, onlyAvailable: false },
      items: [],
      count: 0,
      page: 1,
      take: 50
    }),
    computed: {
      pageCount () {
        return Math.ceil(this.count / this.take)
      },
      locationItems () {
        return [
          { value: null, text: this.use_language.all_location },
          ...this.locations.map(location => ({ value: location.id, text: location.channel + ' : ' + location.name }))
        ]
      },
      header () {
        return [
          { text: this.use_language.location, align: 'left', value: 'locationName', sortable: false, width: '220px' },
          { text: '', align: 'center', value: 'photoLink', sortable: false, width: '70px' },
          { text: this.use_language.product, align: 'left', value: 'productName', sortable: false },
          { text: this.use_language.quota_qty, align: 'right', value: 'quotaQty', sortable: false, width: '110px' },
          { text: this.use_language.reserved_qty, align: 'right', value: 'reservedQty', sortable: false, width: '110px' },
          { text: this.use_language.used_qty, align: 'right', value: 'usedQty', sortable: false, width: '110px' },
          { text: this.use_language.available_qty, align: 'right', value: 'availableQty', sortable: false, width: '110px' }
        ]
      }
    },
    async created () {
      document.title = this.$router.history.current.meta.title
      const context = await getOmsContext()
      this.locations = context.locations || []
      await this.Load_data()
      this.page_loading = false
    },
    methods: {
      formatMoney,
      async search () {
        this.page = 1
        await this.Load_data()
      },
      async Load_data () {
        if (this.locations.length == 0) {
          return
        }
        this.loading = true
        // backend จำกัดผลตาม location ที่ผู้ใช้มีสิทธิ์เสมอ ตัวกรองนี้เลือกได้เฉพาะภายในขอบเขตนั้น
        const response = await getStockList({
          locationId: this.filter.locationId,
          keyword: this.filter.keyword,
          onlyAvailable: this.filter.onlyAvailable,
          skip: (this.page - 1) * this.take,
          take: this.take
        })
        this.loading = false
        if (response.status != 'success') {
          this.$swal({
            position: 'top',
            type: 'error',
            text: response.message || (response.errorCode == 'NETWORK' ? this.use_language.network_error : this.use_language.cannot_perform_operation)
          })
          return
        }
        this.items = response.items
        this.count = response.searchResultCount
      }
    }
  }
</script>
